'use client';
import React from 'react';

import { CampaignSectionTitle, CampaignSectionSubTitle } from '../components/CampaignSectionHeader';
import AmazonProductList from './AmazonProductList';
import SectionContainer from '../components/SectionContainer';
import SectionHeader from '../components/SectionHeader';
import { ProductGrid, ProductGridSkeleton } from '../components/ProductGrid';
import ViewAllButton from '../components/ViewAllButton';
import QueryBoundary from '../../utils/react/QueryBoundary';

export const AmazonSection = () => {
  const handleViewAll = () => {
    if (typeof window !== 'undefined') {
      window.location.href = '/campaign/ggu-lowest-price/';
    }
  };
  return (
    <SectionContainer containerInnerClassName="items-center gap-12" containerInnerStyle={{ backgroundColor: 'black' }}>
      <div className="w-full flex-col items-start m-0 justify-start gap-3 hidden desktop:flex">
        <CampaignSectionTitle theme="dark">Lowest Prices In The World</CampaignSectionTitle>
        <CampaignSectionSubTitle theme="dark">Better than the other mega sale</CampaignSectionSubTitle>
      </div>
      <SectionHeader
        theme="dark"
        title="Lowest Prices In The World"
        subtitle="Better than the other mega sale"
        className="flex desktop:hidden"
        href="/campaign/ggu-lowest-price/"
      />
      <QueryBoundary clientOnly loadingFallback={<ProductGridSkeleton length={5} />}>
        <ProductGrid>
          <AmazonProductList />
        </ProductGrid>
      </QueryBoundary>
      <ViewAllButton onClick={handleViewAll} theme="dark" />
    </SectionContainer>
  );
};
